import { FieldNames } from 'Constants/FieldNames'
import { ValueOf } from 'Src/types/utilTypes'
import { Roles } from 'Constants/Roles'
import { openLink } from 'Helpers'
import { RbidosRequest, TYPE_ORGANIZATION } from 'Pages/registratorCabinet'

export const TYPE_SUBMIT_FORM = {
	UPDATE: 'update',
	PUSH: 'push',
	ROLLBACK_STATUS: 'rollback_status',
	SEND_CODE_EMAIL_OR_PHONE: 'send_code_email_or_phone',
	SEND_CODE_EMAIL_OR_PHONE_AGAIN: 'send_code_email_or_phone_again',
	RETURN_TO_GRID: 'return_to_grid',
	LOAD_DOCUMENT: 'load_document',
	UPDATE_DOCUMENT: 'update_document',
	DELETE_DOCUMENT: 'delete_document',
	UPDATE_DOCUMENT_CUSTOMER_IDENTIFICATION: 'update_document_customer_identification',
	DELETE_DOCUMENT_CUSTOMER_IDENTIFICATION: 'delete_document_customer_identification',
	SEND_TO_INFOTECS: 'send_to_infotecs',
}

export type SubmitFormType = ValueOf<typeof TYPE_SUBMIT_FORM>

export const requiredPushFieldsForClientDataStep = [
	FieldNames.FIRST_NAME,
	FieldNames.LAST_NAME,
	FieldNames.PASSPORT_GIVEN_BY,
	FieldNames.PASSPORT_GIVEN_DEPT,
	FieldNames.PASSPORT_GIVEN_DATE,
	FieldNames.ADDRESS,
	FieldNames.BIRTH_DATE,
	FieldNames.BIRTH_PLACE,
	FieldNames.PASSPORT_NUMBER,
	FieldNames.PASSPORT_SERIES,
	FieldNames.INN,
	FieldNames.SNILS,
	FieldNames.PHONE,
	FieldNames.EMAIL,
	FieldNames.GENDER,
]

export const requiredFieldsForFindOutINN = [
	FieldNames.LAST_NAME,
	FieldNames.FIRST_NAME,
	FieldNames.BIRTH_DATE,
	FieldNames.PASSPORT_SERIES,
	FieldNames.PASSPORT_NUMBER,
	FieldNames.PASSPORT_GIVEN_DATE,
]

export const errorsSbolRetrieval = [
	'lastname_sbol_retrieval_error',
	'firstname_sbol_retrieval_error',
	'middlename_sbol_retrieval_error',
	'bd_sbol_retrieval_error',
	'passport_series.retrieval_error',
	'passport_number.retrieval_error',
	'ps_sbol_retrieval_error',
	'pn_sbol_retrieval_error',
]

export const sbolCommonErrors = [
	'bd_sbol_validation_error',
	'lastname_sbol_validation_error',
	'firstname_sbol_validation_error',
	'middlename_sbol_validation_error',
	'phone_sbol_validation_error',
	'psn_sbol_validation_error',
	'person_compliance_validation_error',
	'sbol_state_not_found',
]

export const errorsNeedChangePhoneNumberSBOL = ['phone_sbol_retrieval_error']

export const selectGender = [
	{ id: 'male', name: 'Мужской' },
	{ id: 'female', name: 'Женский' },
]

export const STATUS_STEP_FORM = {
	OPEN: 'open',
	ERROR: 'error',
	CLOSE: 'close',
	COMPLETED: 'completed',
}

export enum DOC_TYPES {
	USTAVS = 'ustavs',
	PRILOZH_DOCUMS = 'prilozh_docums',
	USER_PASPORT_MAINS = 'user_pasport_mains',
	USER_PASSPORT_FULLS = 'user_passport_fulls',
	USER_PASPORT_PROPISKAS = 'user_pasport_propiskas',
}

export enum DELIVERY_TYPES {
	SMS = 'sms',
	EMAIL = 'email',
}

export enum TaxationOptions {
	USN6 = 'usn6',
	USN15 = 'usn15',
	COMMON = 'common',
	NPD = 'npd',
}

export const TAXATION_OPTIONS_OOO = [
	{
		key: TaxationOptions.USN6,
		value: TaxationOptions.USN6,
		label: 'Упрощенная УСН',
		optionText: '6%',
		description: 'Единый налог к полученным доходам, заменяющий НДФЛ, НДС и налог на имущество.',
	},
	{
		key: TaxationOptions.USN15,
		value: TaxationOptions.USN15,
		label: 'Упрощенная УСН',
		optionText: '15%',
		description:
			'Единый налог с разницы между доходами и расходами по ставке 15% и подается декларация.',
	},
	{
		key: TaxationOptions.COMMON,
		value: TaxationOptions.COMMON,
		label: 'Общая',
		description: 'Должен платить НДС, НДФЛ, налог на имущество и другие налоги',
	},
	{
		key: 'ausn',
		value: 'ausn',
		label: 'АУСН',
		description: 'Автоматизированная упрощенная система налогообложения',
		disabled: true,
		optionIcon: 'lock',
		actionTitle: 'Подробнее',
		actionClick: () => openLink('/knowledge/project/5/article/300/preview'),
	},
]

export const TAXATION_OPTIONS_IP = [
	{
		key: 'usn6',
		value: 'usn6',
		label: 'Упрощенная УСН',
		optionText: '6%',
		description: 'Единый налог к полученным доходам, заменяющий НДФЛ, НДС и налог на имущество.',
	},
	{
		key: 'usn15',
		value: 'usn15',
		label: 'Упрощенная УСН',
		optionText: '15%',
		description:
			'Единый налог с разницы между доходами и расходами по ставке 15% и подается декларация.',
	},
	{
		key: 'common',
		value: 'common',
		label: 'Общая',
		description: 'Должен платить НДС, НДФЛ, налог на имущество и другие налоги',
	},
	{
		key: TaxationOptions.NPD,
		value: TaxationOptions.NPD,
		label: 'Налог на профессиональный доход',
		description: 'Подается заявление с регистрацией ИП на ОСН по закону *',
	},
	{
		key: 'ausn',
		value: 'ausn',
		label: 'АУСН',
		description: 'Автоматизированная упрощенная система налогообложения',
		disabled: true,
		optionIcon: 'lock',
		actionTitle: 'Подробнее',
		actionClick: () => openLink('/knowledge/project/5/article/300/preview'),
	},
]

export const OPTIONS_SELECT_TIME_YEARS = [
	{
		id: 1,
		name: '1 год',
	},
	{
		id: 2,
		name: '2 года',
	},
	{
		id: 3,
		name: '3 года',
	},
	{
		id: 4,
		name: '4 года',
	},
	{
		id: 5,
		name: '5 лет',
	},
]

export const OPTIONS_SELECT_CUSTOMER_POSITION = [
	'Генеральный директор',
	'Директор',
	'Коммерческий директор',
]

export enum OkvedPackagesType {
	GENERAL = 'general',
	PERSONAL = 'personal',
}

export const PRODUCT_ERROR_CODE = {
	REQUIRED_PRODUCT_IDS: 'required_product_ids',
	SAME_GROUP: 'same_group',
	CHECK_ONLINE_FIELDS: 'check_online_fields',
}

export enum RBIDOS_TYPES {
	FREE = 'free',
	PAID = 'paid',
	HYBRID = 'hybrid',
}

export const parametersFields = [FieldNames.ADD_INFO, FieldNames.RATE]

export const terminalFields = [
	FieldNames.EQUIP_TYPE,
	FieldNames.EQUIP_CONNECT_TYPE,
	FieldNames.EQUIP_AMOUNT,
]

export const installRegionDataField = [
	FieldNames.INSTALL_REGION_ID,
	FieldNames.POSADDRESS,
	FieldNames.POS_NAME,
	FieldNames.QUESTIONS_CONTACT_PHONE,
]

export const organizationDataFields = [FieldNames.MCC_CODE_ID, FieldNames.MCC_GROUP_ID]

export const decisionMakerFields = [
	FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
	FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
	FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
]

export const financePersonFields = [FieldNames.FINANCE_PERSON_NAME, FieldNames.FINANCE_PERSON_EMAIL]

export const managerFields = [
	FieldNames.MANAGER_FIRST_NAME,
	FieldNames.MANAGER_LAST_NAME,
	FieldNames.MANAGER_MIDDLE_NAME,
	FieldNames.MANAGER_PHONE,
	FieldNames.MANAGER_EMAIL,
]

export const recognitionFields = {
	PASSPORT_GIVEN_DATE: 'passportIssueDate',
	PASSPORT_GIVEN_BY: 'passportIssuer',
	PASSPORT_GIVEN_DEPT: 'passportIssuerCode',
	PASSPORT_NUMBER: 'passportNumber',
	PASSPORT_SERIES: 'passportSeries',
	GENDER: 'gender',
	LAST_NAME: 'lastName',
	FIRST_NAME: 'firstName',
	MIDDLE_NAME: 'middleName',
	BIRTH_DATE: 'birthDate',
	BIRTH_PLACE: 'birthPlace',
}

export const { LAST_NAME, FIRST_NAME, MIDDLE_NAME, ...consentRecognitionFields } = recognitionFields

export const sberIdFields = [
	FieldNames.PASSPORT_GIVEN_DATE,
	FieldNames.PASSPORT_GIVEN_BY,
	FieldNames.PASSPORT_GIVEN_DEPT,
	FieldNames.PASSPORT_NUMBER,
	FieldNames.GENDER,
	FieldNames.BIRTH_DATE,
	FieldNames.BIRTH_PLACE,
	FieldNames.ADDRESS,
]

export enum typeScenario {
	FREE = 'free',
	PAID = 'paid',
	HYBRID = 'hybrid',
}

export enum TYPE_CABINET {
	FREE = 'free',
	PAID = 'paid',
	DRS = 'drs',
}

export enum TYPE_TRANSFORMER_CABINET {
	NAME_STATUS = 'name_status',
	TITLE_PUSH = 'title_push',
	DESCRIPTION = 'description',
	UPDATE_BUTTON = 'update_button',
}

export type CreateOptionsLead = {
	scenario: typeScenario | null
	with_reserve_account: boolean | null
	online_identification: string | null
}

export const allFormFields = [
	...requiredPushFieldsForClientDataStep,
	FieldNames.MIDDLE_NAME,
	FieldNames.ORG_TYPE,
	FieldNames.TAXATION_SYSTEM,
	FieldNames.OKVED_MAIN_CODE,
	FieldNames.POSITION,
	FieldNames.POSITION_CUSTOMER,
	FieldNames.CONTACT_PHONE,
	FieldNames.ORG_NAME,
	FieldNames.ORG_SHORT_NAME,
	FieldNames.AUTHORIZED_CAPITAL_SIZE,
	FieldNames.TITLE,
	FieldNames.CHIEF_POSITION_TIME_YEARS,
	FieldNames.TARIFF_CODE,
	FieldNames.DIVISION_CODE,
	FieldNames.PUBLIC_OFFICIAL_MARK,
	FieldNames.EIO_MARK,
	FieldNames.ADRS_WORK,
	FieldNames.COVERING_LETTER,
	FieldNames.ANOTHER_COUNTRY_TAXPAYER_MARK,
	FieldNames.PAYMENT_PURPOSE_CONTRACT,
	FieldNames.PAYMENT_PURPOSE_CONTRACT_CUSTOM,
	FieldNames.OWN_USTAV,
	FieldNames.JURIDICAL_ADDRESS,
	FieldNames.POSTAL_ADDRESS,
	FieldNames.OKVED_ADDITIONALS_CODES,
	FieldNames.USER_DOCS,
	FieldNames.INTERNATIONAL_ORG_SHORT_NAME,
	FieldNames.INTERNATIONAL_ORG_NAME,
	FieldNames.EMAIL_FOR_DOCS,
	FieldNames.FOUNDER_INFO,
	FieldNames.ONLINE_PRODUCT_IDS,
	FieldNames.SITE,
	FieldNames.SITE_PRESENT,
	FieldNames.DRS_TARIFF,
	FieldNames.DRS_SBER_GEO_UNIT,
	FieldNames.DRS_CM_VISIT_FLAG,
	FieldNames.ADD_INFO,
	FieldNames.DATE,
	FieldNames.EQUIP_TYPE,
	FieldNames.EQUIP_AMOUNT,
	FieldNames.INSTALL_REGION_ID,
	FieldNames.EQUIP_CONNECT_TYPE,
	FieldNames.POSADDRESS,
	FieldNames.POS_NAME,
	FieldNames.QUESTIONS_CONTACT_PHONE,
	FieldNames.MCC_CODE_ID,
	FieldNames.MCC_GROUP_ID,
	FieldNames.POSADDRESS_FIAS_GUID,
	FieldNames.POSADDRESS_FIAS_LVL,
	FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
	FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
	FieldNames.DECISION_MAKER_PERSON_MIDDLE_NAME,
	FieldNames.FINANCE_PERSON_NAME,
	FieldNames.FINANCE_PERSON_EMAIL,
	FieldNames.MANAGER_LAST_NAME,
	FieldNames.MANAGER_FIRST_NAME,
	FieldNames.MANAGER_MIDDLE_NAME,
	FieldNames.MANAGER_PHONE,
	FieldNames.MANAGER_EMAIL,
]

export const errorsPosaddress = [
	'posaddress_house',
	'posaddress_house_type_full',
	'posaddress_postal_code',
	'posaddress_street',
	'posaddress_street_type_full',
]

export const staticProductsFormRoles = [Roles.QA_EXPERT]

export const SUBTITLE_PASSPORT =
	'Необходимо приложить сканированные копии всех страниц паспорта, согласно требованию ФНС.'

export enum ClientType {
	ALL = 'all',
	IP = 'ip',
	COMPANY = 'company',
}

export const VIEW_LIFTING_CAPACITY = ['01', '04']

export const VIEW_SEATS = ['02', '03']

export const LIMIT_PRICE_LIFTING_CAPACITY = 100

export const LIMIT_PRICE_AREA_SIZE = 1000000

export const LIMIT_PRICE_LIFTING_SEATS = 10000

export const DECIMAL_SCALE = 2

export const passportDataFields = [
	FieldNames.GENDER,
	FieldNames.BIRTH_DATE,
	FieldNames.BIRTH_PLACE,
	FieldNames.PASSPORT_SERIES,
	FieldNames.PASSPORT_NUMBER,
	FieldNames.PASSPORT_GIVEN_DATE,
	FieldNames.PASSPORT_GIVEN_BY,
]

export const getTariffDescription = (item: RbidosRequest) => {
	return [
		{
			title: 'Платежи юрлицам',
			description: 'до 5 шт по 0 руб за платеж',
		},
		{
			title: 'Платежи физлицам',
			description: `${
				item?.org_type === TYPE_ORGANIZATION.OOO ? 'до 300 тыс руб' : 'до 500 тыс руб'
			}`,
		},
		{
			title: 'Приём и зачисление наличных на счёт',
			description: 'до 50 тыс руб – 0 руб',
		},
	]
}

export const PATENT_AVAILABLE_ROLES = [
	Roles.RUKOVODITEL,
	Roles.MANAGER,
	Roles.HEAD_MANAGER,
	Roles.REGISTRAR,
	Roles.TECH_SUPPORT,
	Roles.TECH_SUPPORT_LINE_1,
]
